import styled from "styled-components";

export const EventContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  border-radius: 10px;

  h1 {
    font-family: "Kids Font";
    color: #3089d7;
    font-size: 2rem;
    margin: 0px;
  }

  span {
    color: #3089d7;
    font-size: 1rem;
  }
`;
